import { render, staticRenderFns } from "./TableBase.vue?vue&type=template&id=b1a29e26&scoped=true&"
import script from "./TableBase.vue?vue&type=script&lang=js&"
export * from "./TableBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a29e26",
  null
  
)

export default component.exports